export function useTimeout(type: 'timeout' | 'interval' = 'timeout') {
  const timer = ref<NodeJS.Timeout | null>(null)

  const clearTimer = () => {
    if (!timer.value) return

    switch (type) {
      case 'timeout':
        clearTimeout(timer.value)
        break
      case 'interval':
        clearInterval(timer.value)
        break
    }

    timer.value = null
  }

  onDeactivated(() => {
    clearTimer()
  })

  onBeforeUnmount(() => {
    clearTimer()
  })

  return {
    timer,
    clearTimer,
  }
}
